// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"773":"428027cc","1271":"b9951a9e","5228":"2983ba8b","5250":"b9951a9e","8050":"b9951a9e","8688":"85a95858"}[chunkId] + ".chunk.css";
};